import React, { useState } from "react";
import { CartIcon, DownDropArrow, UpArrowIcon } from "../../utils/svgIcons";
import dsLogoBlackLg from "../../../../Assets/images/ds_black_lg.png";
import "./styles.scss";
import { useSelector } from "react-redux";
import { getAuthToken } from "../../../../Utils/authToken";
import { ProfileViewModal } from "../ProfileViewModal/ProfileViewModal";
import { checkIsStaging, goToDomainCart } from "../../utils/common";
import { getEventPlatform, getUrlParamValue, isDomainCartPage, isDomainPostPurchase, isDomainSearchPage } from "../../../../Utils/common";
import { sendGAEvent } from "../../../../Utils/GAEvents";
import { TRACKING_EVENTS } from "../../../../Utils/GAEvents/gaEventsConstants";
import { DOMAIN, UTM_SOURCE } from "../../../../Utils/constants";

export default function Header(props) {
  const { storeData } = useSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const [openProfile, setOpenProfile] = useState(false);
  const { openCallBackModal, handleOpenVerifyModalFromHeader } = props;
  const handleSetOpenProfile = () => setOpenProfile((prevData) => !prevData);
  const handleCloseOpenProfile = () => setOpenProfile(false);
  const handleLogoClick = () => {
    if (checkIsStaging()) {
      window.location.href = "https://website.digitaldukaan.app/";
    } else {
      window.location.href = "https://digitalshowroom.in/";
    }
  };

  function handleSignIn() {
    handleOpenVerifyModalFromHeader("header");
    sendGAEvent(TRACKING_EVENTS.domainSignInHeader, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });
  }

  function handleCartClick() {
    sendGAEvent(TRACKING_EVENTS.domainCartHeader, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });
    goToDomainCart();
  }

  function handleContactUs() {
    const tracking_event = isDomainSearchPage() ? TRACKING_EVENTS.searchContactUs : isDomainCartPage() ? TRACKING_EVENTS.cartContactUs : isDomainPostPurchase() ? TRACKING_EVENTS.postPurchaseContactUs : null;
    sendGAEvent(tracking_event, {
      dimension1: getUrlParamValue(DOMAIN),
      dimension2: getEventPlatform(),
      dimension3: getUrlParamValue(UTM_SOURCE),
      // Add more dimensions as needed
    });
    openCallBackModal && openCallBackModal();
  }

  return (
    <div className="header__container">
      <div className="header_logo_section" onClick={handleLogoClick}>
        <img src={dsLogoBlackLg} className="ds-logo" />
      </div>
      <div className="header_nav_link_section">
        {getAuthToken() ? 
          <span
            className="number_section"
            onClick={() => {
              handleSetOpenProfile();
            }}
          >
            <>
              {storeData?.owner?.phone}{openProfile ? <span><UpArrowIcon/></span> : <span><DownDropArrow/></span>}{" "}
              {openProfile && 
                <ProfileViewModal
                  mobileNo={storeData?.owner?.phone}
                  handleCloseOpenProfile={handleCloseOpenProfile}
                  postPurchase={props?.postPurchase}
                />
              }
            </>
          </span>
         : 
          <span
            onClick={() => handleSignIn()}
          >
            Sign in
          </span>
        }

        <span onClick={() => handleContactUs()}>Contact Us</span>
        {!props?.hideCart && 
          <div className="cart-logo-container">
            <span className="cart" onClick={() => handleCartClick()}>
              <CartIcon />
            </span>
            {props.domainCart?.items?.length > 0 ? 
              <span className="cart-size">{props.domainCart?.items?.length}</span>
             : null}
          </div>
        }
      </div>
    </div>
  );
}
